module.exports = __webpack_public_path__ + "static/media/project3.78f0322c.jpg";